module.exports = __webpack_public_path__ + "img/9788992997065.9d37bccb.jpg";